import React from "react";
import "./AboutStuttering.css";
import placeholder from "./assets/image.png";
import Footer from "../Footer";
import QuestionsPreview from "../QuestionsPreview";
import LatestInfo from "../LatestInfo";

const sampleFaq = [
  { title: "Kérdés jön ide majd", answer: "Válasz ide jön majd. Válasz ide jön majd. Válasz ide jön majd. Válasz ide jön majd. Válasz ide jön majd. Válasz ide jön majd. Válasz ide jön majd. Válasz ide jön majd. Válasz ide jön majd." },
  { title: "Kérdés jön ide majd", answer: "Válasz ide jön majd." },
  { title: "Kérdés jön ide majd", answer: "Válasz ide jön majd." },
  { title: "Kérdés jön ide majd", answer: "Válasz ide jön majd." },
  { title: "Kérdés jön ide majd", answer: "Válasz ide jön majd." },
  { title: "Kérdés jön ide majd", answer: "Válasz ide jön majd." },
  { title: "Kérdés jön ide majd", answer: "Válasz ide jön majd." },
];

const AboutStuttering = () => {
  return (
    <main className="aboutstuttering">

      <div className="as-hero-wrap">
        <div
          className="as-hero-image"
          style={{ backgroundImage: `url(${placeholder})` }}
        ></div>
      </div>

      <section className="as-content-wrapper">
        <div className="article-grid">
          <article className="article-left">
            <h1>A dadogásról</h1>

            <p>A dadogás pontos okai még nem ismertek, több megközelítés létezik. A neurológiai érintettség bizonyított, vagyis hogy a dadogók más agyi idegpályákat használnak a beszédben, mint a folyamatos beszélők. Ez az állapot egy bizonyos kor után (kb. 7 éves kor) a legjobb tudásunk szerint már nem múlik el, de tünetmentessé válhat valaki (például más idegpályák kiépítésével-használatával). A kutatások szerint genetikai faktor is szerepet játszik: az érintettek 65%-nál találtak más érintettet is a családban (ez a szám magasabb is lehet, mivel sokan, főleg a régebbi generációk esetében, titkolják, szégyellik a dadogásukat). Poligénes ikervizsgálatok is rendelkezésre állnak, az együttható 90% feletti.</p>

            <p>Emellett pszichoszociális tényezőktől is nagyban függ a beszéd, illetve a dadogás aktuális minősége: számít a beszédhelyzet, a beszédtéma, a fáradtsági szint, a beszélgetőpartner személye. Érdekes, hogy nemcsak a rossz hangulat van hatással a dadogásra, hanem a kitörő jó hangulat, az izgatottság is.</p>

            <p>A fentiekből is látszik, hogy a dadogó emberek valószínűleg nem azért dadognak, mert gyerekkorukban egy konkrét trauma érte őket, amit még nem tudtak feldolgozni – az ilyesmi legfeljebb triggerként, súlyosbító tényezőként szolgálhat. Legtöbbször azért tűnhetnek idegesebbnek, mert sok negatív tapasztalatuk volt a beszéddel kapcsolatban, és fizikailag is nehezebben megy nekik.</p>

            <p>Dadogóként tehát azért lehetünk idegesek, mert dadogunk, és nem azért dadogunk, mert idegesek vagyunk. Ez egy nagyon fontos különbség! Ezért a legtöbb dadogónak egyáltalán nem segít, ha azt mondják neki: nyugi, csak lassan, nem kell izgulni. Sőt, ez gyakran még jobban frusztrálja az érintetteket, mert a dadogásukra helyeződik a fókusz. 
            Ami biztosan segít: türelmes, empatikus hozzáállás; ne a dadogáson legyen a fókusz, hanem azon, amit a dadogó személy mond (üzenet). És nem kell helyette kimondani-befejezni a szavakat, mondatokat, csak kivárni, amíg ő maga elmondja. (Ez nyilván igényel némi alkalmazkodást a beszélgetőpartnertől – a dadogók türelemre, elfogadásra tanítanak).</p>
          </article>

          <aside className="article-right">
            <div className="publish-date">2025. NOVEMBER 16.</div>

            <div className="author-frame">
              <img src={placeholder} alt="Author" className="author-photo" />

              <div className="author-details">
                <span className="author-name">Hojdák Gergely</span>
                <span className="author-role">Szerző</span>
              </div>
            </div>
          </aside>
        </div>
      </section>
      <LatestInfo />
      <QuestionsPreview
        questions={sampleFaq}
        onSeeAll={() => (window.location.href = "/faq")}
      />
      <Footer />
    </main>
  );
};

export default AboutStuttering;
